import Vector3 from '../math/Vector3';
import Matrix4x4 from '../math/Matrix4x4';
import ArrayTreeNode from '../lists/ArrayTreeNode';
// import AABB3 from '../math/AABB3';

export default class Transform3D extends ArrayTreeNode {
	position: Vector3;
	scales: Vector3;
	pivots: Vector3;
	rotation: Vector3;

	// computed properties
	globalTransform: Matrix4x4;
	// bounds: AABB3

	constructor () {
		super();

		this.position = new Vector3(0, 0, 0);
		this.scales = new Vector3(1, 1, 1);
		this.pivots = new Vector3(0, 0, 0);
		this.rotation = new Vector3(0, 0, 0);

		this.globalTransform = new Matrix4x4();
		// this.bounds = new AABB3([0, 0, 0, 0, 0, 0]);
	}

	set scale (scale: number) {
		this.scales.x = scale;
		this.scales.y = scale;
		this.scales.z = scale;
	}

	get scale () {
		return (this.scales.x + this.scales.y + this.scales.z) / 3;
	}

	set pivot (pivot: number) {
		this.pivots.x = pivot;
		this.pivots.y = pivot;
		this.pivots.z = pivot;
	}

	get pivot () {
		return (this.pivots.x + this.pivots.y + this.pivots.z) / 3;
	}

	update (parentTransform: Matrix4x4) {
		this.globalTransform.set(parentTransform)
			.translate(this.position)
			.rotateX(this.rotation.x)
			.rotateY(this.rotation.y)
			.rotateZ(this.rotation.z)
			.scale(this.scales)
			.translate(this.pivots, -1);

		if (this.children !== null) {
			for (let t = 0; t < this.children.length; t++) {
				this.children[t].update(this.globalTransform);
			}
		}
	}
}
